import { hardRefreshAndEmptyCache } from "_helpers";
import ContainerButton from "_lib/ContainerButton";
import { Typography } from "antd";
import React, { useCallback } from "react";
import {
  StyledNewVersionInfoModalContent,
  StyledNewVersionInfoModalFooter,
} from "./index.styled";
import updateAnimatedData from "_assets/lottie/lib/update.json";
import AppLottie from "_lib/AppLottie";

const { Text } = Typography;

export const NewVersionInfoModalContent = () => {
  return (
    <StyledNewVersionInfoModalContent>
      <Text strong>Hi There 👋</Text>
      <Text strong>A new version of the app is available.</Text>
      <AppLottie
        animationData={updateAnimatedData}
        loop
        className="lottie-update"
        size={200}
      />
      <Text>
        For best user experience we recommend that you always use the most
        current version
      </Text>
    </StyledNewVersionInfoModalContent>
  );
};

export const NewVersionInfoModalFooter = () => {
  const onClickUpdate = useCallback(() => {
    hardRefreshAndEmptyCache();
  }, []);
  return (
    <StyledNewVersionInfoModalFooter>
      <ContainerButton
        fullWidth
        type="primary"
        size="middle"
        title={`Click Here to Update`}
        onClick={onClickUpdate}
      />
    </StyledNewVersionInfoModalFooter>
  );
};
